import styled from '@emotion/styled';
import { Avatar, Badge } from '@galaxy-react/core';
type AvatarContent = {
  name: string;
  color: string;
};

export type DocumentActionAvatarProps = {
  subscribers?: AvatarContent[];
};

const ActionAvatarWrapperStyled = styled('div')({
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
});

export const DocumentActionAvatar = ({ subscribers = [] }: DocumentActionAvatarProps) => {
  return (
    <ActionAvatarWrapperStyled>
      {subscribers && subscribers.length > 1
        ? subscribers
            ?.slice(0, 3)
            .map((subscriber) => (
              <Avatar
                title={subscriber.name}
                key={subscriber.name}
                idForColor={subscriber.color}
                name={subscriber.name}
                size={24}
              />
            ))
        : subscribers?.map((subscriber) => (
            <Avatar
              title={subscriber.name}
              key={subscriber.name}
              idForColor={subscriber.color}
              name={subscriber.name}
              size={24}
            />
          ))}

      {subscribers && subscribers.length > 3 ? <Badge variant="circular" count={subscribers.length - 3} /> : null}
    </ActionAvatarWrapperStyled>
  );
};

export default DocumentActionAvatar;
